import PropTypes from 'prop-types';
export var propTypes = {
    activeTab: PropTypes.number,
    onTabSelect: PropTypes.func.isRequired,
    children: PropTypes.node
};
//# sourceMappingURL=types.js.map